import { render } from "./PassIcon.vue?vue&type=template&id=7e489862"
import script from "./PassIcon.vue?vue&type=script&lang=js"
export * from "./PassIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__